(function () {

    window.oneadvanced = window.oneadvanced || {};
    window.oneadvanced.observer = window.oneadvanced.observer || {};
    window.oneadvanced.observer.init = function () {
        //console.log("initialising observer...");

        // IntersectionObserver
        if ('IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

            var theObservered = document.querySelectorAll('.card, .o-fade');

            var observer = new IntersectionObserver((entries, self) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        entry.target.classList.add('fadeInUp');
                        entry.target.addEventListener('animationend', animationEndCallback);
                        self.unobserve(entry.target);
                    }
                });
            });

            theObservered.forEach(observation => {
                observer.observe(observation);
            });

        }
        function animationEndCallback(event) {
            this.removeEventListener('animationEnd', animationEndCallback);
            this.classList.remove('fadeInUp');
        }

        // MutationObserver

        // Options for the observer (which mutations to observe)
        window.oneadvanced.observer.mutation_observer = window.oneadvanced.observer.mutation_observer || {};
        window.oneadvanced.observer.mutation_observer_config = window.oneadvanced.observer.mutation_observer_config || { attributes: true, attributeFilter: ['class'], childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
            // Use traditional 'for loops' for IE 11
            for (var mutationIndex = 0; mutationIndex < mutationsList.length; mutationIndex++) {
                if (mutationsList[mutationIndex].type === 'attributes' && mutationsList[mutationIndex].target.className === 'slick-slide slick-cloned') {
                    //console.log('The ' + mutationsList[mutationIndex].attributeName + ' attribute was modified.');
                    var img = mutationsList[mutationIndex].target.getElementsByTagName('img')[0];
                    if (img && window.oneadvanced.lazyload.hasLoaded) {
                        window.oneadvanced.lazyload.observer.observe(img);
                    } else {
                        //console.log("The lazy loading observer has not been loaded. Unable to observe.")
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        window.oneadvanced.observer.mutation_observer = new MutationObserver(callback);
    };
    window.oneadvanced.observer.hasLoaded = true;

})();